<div class="main-div content-w-98">
  <div class="title-div">
    <div class="headerName">
      <span>Product reporting</span>
    </div>
    <div class="subTitleName">
      <span>Generate your report </span>
    </div>
  </div>

  <div class="dropdowns-div mainInputDiv">
    <form [formGroup]="reportForm">
      <!-- Edit report title -->
      <div class="row">
        <div class="col-12">
          <p class="note-div gray-font">Edit report name</p>
        </div>
        <div class="col-12 input-div">
          <div class="form-group required" aria-required="true">
            <div class="form-group required" aria-required="true">
              <piqet-angular-common-input
                [label]="REPORT_FORM_LABEL.REPORT_TITLE"
                name="reportTitle"
                [placeholder]="REPORT_FORM_PLACEHOLDER.REPORT_TITLE"
                formControlName="reportTitle"
                [control]="reportForm.controls['reportTitle']"
                [submitted]="finalSubmit"
                inputType="text"
                [required]="true"
                [preventDot]="true"
                [errorMessages]="{
                  required: 'Please enter report title'
                }"
              ></piqet-angular-common-input>
            </div>
          </div>
        </div>
      </div>

      <!-- Report name -->
      <!-- <div class="d-flex  justify-content-end " *ngIf="showEdit && showCustomProjectSetting">
                  <a class="add-link" target="_blank" routerLink="/my-organization/project-report-setting"><span
                          class="redirectLinkText">Add project report custom setting</span></a>
                  <a class="setLinkIconPosition" target="_blank" replaceUrl="true"
                      routerLink="/my-organization/project-report-setting">
                      <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13">
                  </a>
                  <span class="setLinkIconPosition"><img src="./assets/icons/refresh-circle.svg" alt="" width="14"
                          height="13"></span>
              </div> -->

      <!-- Report formate and report type -->
      <div class="row scenarios-div ng-select-div reportGenerationDrd">
        <div class="col-12 col-md-6">
          <label class="labelColor">{{ REPORT_FORM_LABEL.REPORT_FORMAT }} *</label>
          <ng-select
            [clearable]="false"
            [clearOnBackspace]="false"
            #reportFormate
            stepPosition="top"
            [placeholder]="REPORT_FORM_PLACEHOLDER.REPORT_FORMAT"
            text="Select from a PDF, PPT or excel report format."
            formControlName="reportFormate"
            [items]="reportFormateList"
            [searchable]="false"
            bindLabel="name"
            bindValue="id"
            [searchFn]="commonInputSearchName"
            [multiple]="false"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  (input)="reportFormate.filter($any($event.target).value)"
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div
                [ngOptionHighlight]="search"
                title="{{ item?.name }}"
                [class.disabled]="item?.disabled"
              >
                {{ item.name }}
              </div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              reportForm.controls['reportFormate']?.touched &&
              reportForm.controls['reportFormate']?.invalid
            "
            class="input-error"
          >
            Report format is required
          </div>
        </div>

        <!-- <div class="col-12 col-md-6 reportGenerationDrd">
                      <label class="labelColor">Report type *</label>
                      <ng-select [clearable]="false" [clearOnBackspace]="false" #reportType joyrideStep="adv-15"
                          stepPosition="top" text="Select a predefined report or create your own custom report."
                          formControlName="reportType" [items]="reportTypeList" [searchable]="false" bindLabel="name"
                          [searchFn]="commonInputSearchName" [multiple]="false"
                          groupBy="childItems">
                          <ng-template ng-header-tmp>
                              <div class="has-feedback">
                                  <input placeholder="Search..." (input)="reportType.filter($any($event.target).value)"
                                      type="text" class="form-control search-input" id="inputValidation" />
                                  <span class="form-control-feedback">
                                      <i class="fa fa-search icon"></i>
                                  </span>
                              </div>
                          </ng-template>
                          <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                              <div [ngOptionHighlight]="search" title="{{item?.name}}">
                                  {{ item?.name }}
                              </div>
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                              <div [ngOptionHighlight]="search" title="{{item?.name}}">
                                  {{ item?.name }}
                              </div>
                          </ng-template>
                      </ng-select>
                      <div *ngIf="
                        reportForm.controls['reportType']?.touched && reportForm.controls['reportType']?.invalid"
                          class="input-error">
                          Report type is required
                      </div>
                  </div> -->
      </div>

      <!-- Report scenario -->
      <div class="scenarios-to-include-div">
        <div class="row">
          <!-- <div class="col-12">
                          <p *ngIf="chooseUpToScenarioMessage != ''" class="note-div gray-font">
                              {{chooseUpToScenarioMessage}}</p>
                      </div> -->
          <div class="col-12 ng-select-div reportGenerationDrd">
            <label class="labelColor">Select up to 6 products</label>
            <ng-select
              #scenario
              [placeholder]="REPORT_FORM_PLACEHOLDER.PRODUCTS"
              formControlName="reportScenarios"
              [clearable]="false"
              [items]="reportScenarioList"
              [searchable]="false"
              bindLabel="description"
              bindValue="idStr"
              [searchFn]="commonInputSearchDescription"
              [maxSelectedItems]="maxAllowedSelectedItems"
              [multiple]="true"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control search-input"
                    id="inputValidation"
                    (input)="scenario.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item?.description }}
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                reportForm.controls['reportScenarios']?.touched &&
                reportForm.controls['reportScenarios']?.invalid
              "
              class="input-error"
            >
              Please select products
            </div>
          </div>
        </div>
      </div>

      <!-- Functional unit and base scenario -->
      <div class="row scenarios-div ng-select-div reportGenerationDrd">
        <div class="col-12 col-md-6 reportGenerationDrd">
          <label class="labelColor">{{ REPORT_FORM_LABEL.FUNCTIONAL_UNIT }} *</label>
          <ng-select
            [clearable]="false"
            [clearOnBackspace]="false"
            [placeholder]="REPORT_FORM_PLACEHOLDER.FUNCTIONAL_UNIT"
            #functionalUnit
            formControlName="functionalUnit"
            [items]="functionalUnitList"
            [searchable]="false"
            bindLabel="name"
            [multiple]="false"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  (input)="functionalUnit.filter($any($event.target).value)"
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                {{ item?.name }}
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                {{ item?.name }}
              </div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              reportForm.controls['functionalUnit']?.touched &&
              reportForm.controls['functionalUnit']?.invalid
            "
            class="input-error"
          >
            Functional unit is required
          </div>
        </div>
        <div class="col-12 col-md-6">
          <label class="labelColor">{{ REPORT_FORM_LABEL.PRODUCT_BASE_SCENARIO }} *</label>
          <ng-select
            [clearable]="false"
            [clearOnBackspace]="false"
            #baseScenario
            [placeholder]="REPORT_FORM_PLACEHOLDER.PRODUCT_BASE_SCENARIO"
            formControlName="baseScenario"
            [items]="reportScenarioList"
            [searchable]="false"
            bindLabel="name"
            [multiple]="false"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  (input)="baseScenario.filter($any($event.target).value)"
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div
                [ngOptionHighlight]="search"
                title="{{ item?.name }}"
                [class.disabled]="item?.disabled"
              >
                {{ item.name }}
              </div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              reportForm.controls['baseScenario']?.touched &&
              reportForm.controls['baseScenario']?.invalid
            "
            class="input-error"
          >
            Base scenarios required
          </div>
        </div>
      </div>

      <!-- Impact categories -->
      <div class="row ng-select-div">
        <div class="col-12 col-md-12 reportGenerationDrd">
          <label class="labelColor">{{ REPORT_FORM_LABEL.IMPACT_CATEGORIES }} *</label>
          <ng-select
            [clearable]="false"
            [clearOnBackspace]="false"
            [placeholder]="REPORT_FORM_PLACEHOLDER.IMPACT_CATEGORIES"
            #impactCategories
            formControlName="impactCategories"
            [items]="impactCategoriesList"
            [searchable]="false"
            bindLabel="name"
            (change)="onCustomCategoriesChange($event)"
            [multiple]="false"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  (input)="impactCategories.filter($any($event.target).value)"
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                {{ item?.name }}
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                {{ item?.name }}
              </div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              reportForm.controls['impactCategories']?.touched &&
              reportForm.controls['impactCategories']?.invalid
            "
            class="input-error"
          >
            Impact categories is required
          </div>
        </div>
      </div>

      <!-- Categories to include -->
      <div class="row ng-select-div" *ngIf="isShowCustomCategories">
        <div class="col-12 col-md-12 reportGenerationDrd">
          <label class="labelColor">{{ REPORT_FORM_LABEL.CATEGORIES_INCLUDE }} *</label>
          <ng-select
            [clearable]="false"
            [clearOnBackspace]="false"
            #customCategories
            [placeholder]="REPORT_FORM_PLACEHOLDER.CATEGORIES_INCLUDE"
            formControlName="categoriesToInclude"
            [items]="customCategoriesList"
            [searchable]="false"
            bindValue="id"
            bindLabel="name"
            [multiple]="true"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  (input)="customCategories.filter($any($event.target).value)"
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                {{ item?.name }}
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                {{ item?.name }}
              </div>
            </ng-template>
          </ng-select>
          <div *ngIf="reportForm.controls['categoriesToInclude']?.invalid" class="input-error">
            Categories to include is required
          </div>
        </div>
      </div>

      <hr class="hr" />

      <!-- buttons -->
      <div class="setButtonAndError text-margin">
        <div class="modal-footer">
          <button
            class="modelBtn"
            (click)="onGenerate('save')"
            *ngIf="showEdit && !isSelectedReportExport"
          >
            Save
          </button>
          <button
            [innerHTML]="buttonName"
            type="submit"
            class="ISOsaveBtn"
            (click)="onGenerate()"
          ></button>
        </div>

        <div
          class="redErrorTag"
          *ngIf="
            finalSubmit &&
            (reportForm.controls['reportTitle']?.invalid ||
              reportForm.controls['reportFormate']?.invalid ||
              reportForm.controls['reportType']?.invalid ||
              reportForm.controls['reportScenarios']?.invalid ||
              reportForm.controls['functionalUnit']?.invalid ||
              reportForm.controls['baseScenario']?.invalid ||
              reportForm.controls['impactCategories']?.invalid)
          "
        >
          <div class="bigScreenErrContain">
            <div>
              <span> <img src="./assets/icons/swalDeletion.svg" width="53" height="48" /></span>
            </div>
            <div>
              <div class="mb-3">
                <span style="color: #f00">To proceed please complete the following fields : </span>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportForm.controls['reportTitle']?.invalid">
                  Please enter report title
                </div>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportForm.controls['reportFormate']?.invalid">
                  Report format is required
                </div>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportForm.controls['reportType']?.invalid">
                  Report type is required
                </div>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportForm.controls['reportScenarios']?.invalid">
                  Please select products
                </div>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportForm.controls['functionalUnit']?.invalid">
                  Functional unit is required
                </div>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportForm.controls['baseScenario']?.invalid">
                  Base product required
                </div>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportForm.controls['impactCategories']?.invalid">
                  Impact categories is required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
